module.exports = "/matchcenter-staging/assets/images/extra3.30affd1eb3b24e42846ed9785aea307a.png";